<template>
  <div>
    <div class="page-wrapper">
      <Header />
      <body class="ltr">
      <div class="page-body-wrapper">
        <div class="page-sidebar" :class="!togglesidebar ? 'open' : ''" v-if=" this.$route.path!='/dashboard/default'">
          <!-- La sidebar reste montée en permanence : elle est simplement
               déplacée à l'ouverture/fermeture, sans montage/démontage
               inutile (voir sidebar.vue pour son rendu mobile). -->
          <Sidebar
            class="switch"
            @clicked="sidebar_toggle"
          />
        </div>
        <div class="page-body">
          <transition name="fadeIn" enter-active-class="animated fadeIn">
            <router-view class="view"></router-view>
          </transition>
        </div>
        <Footer />
      </div>
      </body>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Header from "./UI/header.vue";
import Sidebar from "./UI/sidebar.vue";
import Footer from "./UI/footer.vue";

export default {
  name: "mainpage",
  data() {
    return {
      rightsidebar_toggle_var: false,
      mobileheader_toggle_var: false,
      sidebar_toggle_var: false,
      horizontal_Sidebar: true,
      resized: false
    };
  },
  // props:['sidebar_toggle_var'],
  components: {
    Header,
    Sidebar,
    Footer
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data,
      layout: state => state.layout.layout,
      transparentbg: state => state.layout.transparentbg,
      togglesidebar: state => state.menu.togglesidebar
    })
  },
  watch: {
    $route() {
      this.menuItems.filter(items => {
        if (items.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", items);
        if (!items.children) return false;
        items.children.filter(subItems => {
          if (subItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subItems);
          if (!subItems.children) return false;
          subItems.children.filter(subSubItems => {
            if (subSubItems.path === this.$route.path)
              this.$store.dispatch("menu/setActiveRoute", subSubItems);
          });
        });
      });
      // Sur mobile, le menu doit se refermer après un clic sur une de
      // ses entrées (changement de page) pour ne pas rester par-dessus
      // le contenu.
      this.closeSidebarOnMobile();
    },
  },
  mounted() {
    // À l'arrivée dans le panel, le menu doit être fermé sur mobile : il
    // s'ouvre uniquement avec l'icône du header et ne recouvre pas le
    // contenu dès la première visite. Sur ordinateur il reste ouvert.
    this.closeSidebarOnMobile();
  },
  methods: {
    closeSidebarOnMobile() {
      // 992 px = point de rupture du gabarit (max-width: 991px) : en
      // dessous, le menu latéral est un panneau qui recouvre le contenu.
      if (window.innerWidth < 992 && this.togglesidebar) {
        this.$store.dispatch("menu/setSidebar", false);
      }
    },
    sidebar_toggle(value) {
      this.sidebar_toggle_var = !value;
    },
    rightsidebar_toggle(value) {
      this.rightsidebar_toggle_var = value;
    },
    mobiletoggle_toggle(value) {
      this.mobileheader_toggle_var = value;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
